import React, { useEffect } from 'react';
import api from '../../services/api';
 
 
 
 


const CDA: React.FC = () => {

  useEffect(() => {

    api.get('/cda');
  }, [])
  return (
    <>

      <div className='full-width column column pad '>


        <h2 style={{ color: '#555', fontSize: '16px', lineHeight: '20px' }} className="text-left width-full">Página não encontrada</h2>

      </div>
    </>
  );
};
export default CDA;
